// List of all weather stations
import Leaflet from 'leaflet';

//#region Weather station location for wind
export function windWeatherStationLatLon(location: string): Leaflet.LatLngExpression
{
    let result: Leaflet.LatLngExpression = [0,0];
    switch(location) {
        case "Chek Lap Kok":
            result = [22.328307, 113.8947261];
            break;
        case "Central Pier":
            result = [22.28888889, 114.15583333];
            break;
        case "Cheung Chau":
            result = [22.20111111, 114.02666667];
            break;
        case "Cheung Chau Beach":
            result = [22.21683333, 114.02916667];
            break;
        case "Green Island":
            result = [22.285, 114.11277778];
            break;
        case "Kai Tak":
            result = [22.30972222, 114.21333333];
            break;
        case "King's Park":
            result = [22.31194444, 114.17277778];
            break;
        case "Lamma Island":
            result = [22.22611111, 114.10861111];
            break;
        case "Lau Fau Shan":
            result = [22.46888889, 113.98361111];
            break;
        case "Ngong Ping":
            result = [22.25861111, 113.91277778];
            break;
        case "North Point":
            result = [22.294444, 114.199722];
            break;
        case "Peng Chau":
            result = [22.29111111, 114.04333333];
            break;
        case "Sai Kung":
            result = [22.37555556, 114.27444444];
            break;
        case "Sha Chau":
            result = [22.345833, 113.891111];
            break;
        case "Sha Tin":
            result = [22.4025, 114.21];
            break;
        case "Shek Kong":
            result = [22.43611111, 114.08147222];
            break;
        case "Stanley":
            result = [22.1975, 114.2093695];
            break;
        case "Star Ferry":
            result = [22.293056, 114.168611];
            break;
        case "Ta Kwu Ling":
            result = [22.52861111, 114.15666667];
            break;
        case "Tai Mei Tuk":
            result = [22.47527778, 114.2375];
            break;
        case "Tai Po Kau":
            result = [22.442500, 114.184167];
            break;
        case "Tap Mun":
            result = [22.468333, 114.363056];
            break;
        case "Tate's Cairn":
            result = [22.35777778, 114.21777778];
            break;
        case "Tseung Kwan O":
            result = [22.31583333, 114.25555556];
            break;
        case "Tsing Yi":
            result = [22.346667, 114.086389];
            break;
        case "Tuen Mun":
            result = [22.38583333, 113.96416667];
            break;
        case "Waglan Island":
            result = [22.18222222, 114.30333333];
            break;
        case "Wetland Park":
            result = [22.46666667, 114.00888889];
            break;
        case "Wong Chuk Hang":
            result = [22.24777778, 114.17361111];
            break;
        case "Hong Kong Sea School":
            result = [22.2183973, 114.211579];
            break;
        default:
            break;
    }
    return result;
}
//#endregion

//#region tide station location
export function tideStationLatLon(location: string): Leaflet.LatLngExpression 
{
    let result: Leaflet.LatLngExpression = [0,0];
    switch(location) {
        case "Quarry Bay":
          result = [22.291111, 114.213333];
          break;
        case "Shek Pik":
          result = [22.220278, 113.894444];
          break;
        case "Tsim Bei Tsui":
          result = [22.487222, 114.014167];
          break;
        case "Tai Miu Wan":
          result = [22.269722, 114.288611];
          break;
        case "Tai Po Kau":
          result = [22.442500, 114.183889];
          break;
        case "Waglan Island":
          result = [22.183056, 114.302778];
          break;
        case "Tai O":
          result = [22.253500, 113.863778];
          break;
        case "Kwai Chung":
          result = [22.323611, 114.122222];
          break;
        case "Ma Wan":
          result = [22.363888, 114.071388];
          break;
        case "Cheung Chau":
          result = [22.214444, 114.023055];
          break;
        case "Ko Lau Wan":
          result = [22.458611, 114.360833];
          break;
        case "Sha Kiu Tau":
          result = [22.348000, 114.353000];
          break;
        case "Chek Lap Kok (East)":
          result = [22.320346, 113.945483];
          break;
        case "Chek Lap Kok (West)":
          result = [22.304644, 113.896849];
          break;
        default:
          break;
    }
    return result;
}
//#endregion

//#region rain station location
export function rainStationLatLon(location: string): Leaflet.LatLngExpression 
{
    let result: Leaflet.LatLngExpression = [0,0];

    switch(location) {
        case "Chek Lap Kok":
            result = [22.328307, 113.8947261];
            break;
        case "Hong Kong International Airport":
            result = [22.309444, 113.921944];
            break;
        case "Central Pier":
            result = [22.28888889, 114.15583333];
            break;
        case "Cheung Chau":
            result = [22.20111111, 114.02666667];
            break;
        case "Cheung Chau Beach":
            result = [22.21083333, 114.02916667];
            break;
        case "Clear Water Bay":
          result = [22.26333333, 114.29972222];
          break;
        case "Green Island":
            result = [22.285, 114.11277778];
            break;
        // case "Hong Kong Sea School":
        //   result = [22.285, 114.11277778];
        //   break;
        case "Kai Tak":
            result = [22.30972222, 114.21333333];
            break;
        case "King's Park":
            result = [22.31194444, 114.17277778];
            break;
        case "Kowloon City":
            result = [22.335, 114.18472222];
            break;
        case "Kwun Tong":
            result = [22.31861111, 114.22472222];
            break;
        case "Lamma Island":
            result = [22.22611111, 114.10861111];
            break;
        case "Lau Fau Shan":
            result = [22.46888889, 113.98361111];
            break;
        case "Ngong Ping":
            result = [22.25861111, 113.91277778];
            break;
        case "North Point":
            result = [22.294444, 114.199722];
            break;
        case "Pak Tam Chung":
            result = [22.40277778, 114.32305556];
            break;
        case "Peng Chau":
            result = [22.29111111, 114.04333333];
            break;
        case "Sai Kung":
            result = [22.37555556, 114.27444444];
            break;
        case "Sha Chau":
            result = [22.345833, 113.891111];
            break;
        case "Sha Tin":
            result = [22.4025, 114.21];
            break;
        case "Sham Shui Po":
            result = [22.33583333, 114.13694444];
            break;
        case "Shau Kei Wan":
            result = [22.28166667, 114.23611111];
            break;
        case "Shek Kong":
            result = [22.43611111, 114.08147222];
            break;
        case "Sheung Shui":
            result = [22.50194444, 114.11111111];
            break;
        case "Stanley":
            result = [22.21416667, 114.21861111];
            break;
        case "Star Ferry":
            result = [22.293056, 114.168611];
            break;
        case "Ta Kwu Ling":
            result = [22.52861111, 114.15666667];
            break;
        case "Tai Lung":
            result = [22.48472222, 114.1175];
            break;
        case "Tai Mei Tuk":
            result = [22.47527778, 114.2375];
            break;
        // case "Tai Mo Shan":
        //   result = [22.41055556, 114.12444444];
        //   break;
        case "Tai Po Market":
            result = [22.44611111, 114.17888889];
            break;
        case "Tai Po Kau":
            result = [22.442500, 114.184167];
            break;
        case "Tap Mun":
            result = [22.468333, 114.363056];
            break;
        case "Tate's Cairn":
            result = [22.35777778, 114.21777778];
            break;
        case "The Peak":
            result = [22.26416667, 114.155];
            break;
        case "Tseung Kwan O":
            result = [22.31583333, 114.25555556];
            break;
        case "Tsing Yi":
            result = [22.346667, 114.086389];
            break;
        case "Tsuen Wan Ho Koon":
            result = [22.38361111, 114.10777778];
            break;
        // case "Tsuen Wan Shing Mun Valley":
        //   result = [22.37555556, 114.12666667];
        //   break;
        case "Tuen Mun":
            result = [22.38583333, 113.96416667];
            break;
        case "Waglan Island":
            result = [22.18222222, 114.30333333];
            break;
        case "Wetland Park":
            result = [22.46666667, 114.00888889];
            break;
        case "Wong Chuk Hang":
            result = [22.24777778, 114.17361111];
            break;
        case "Wong Tai Sin":
            result = [22.33944444, 114.20527778];
            break;
        case "Yuen Long Park":
            result = [22.44083333, 114.01833333];
            break;
        case "Shui Pin Wai":
            result = [22.4448125, 114.0082026];
            break;
        case "Cheung Ching":
            result = [22.3474692,114.1079903];
            break;
        case "Broadcast Drive":
            result = [22.3410076, 114.1826856];
            break;
        case "San Po Kong":
            result = [22.3364426, 114.1989259];
            break;
        case "Happy Valley":
            result = [22.268352, 114.1865135];
            break;
        case "Magazine Gap":
            result = [22.2726784, 114.1620175];
            break;
        case "Hong Kong Observatory":
            result = [22.3022517, 114.1744549];
            break;
        case "King’s Park":
            result = [22.3095048, 114.1751471];
            break;
        case "Kau Sai Chau":
            result = [22.3615399, 114.3133433];
            break;
        default:
            break;
    }

    return result;
}
//#endregion

//#region temp and hum station location
export function tempHumStationLatLon(location: string): Leaflet.LatLngExpression {
    let result: Leaflet.LatLngExpression = [0,0];
    switch(location) {
      case "Chek Lap Kok":
        result = [22.30944444, 113.92194444];
        break;
      case "Cheung Chau":
        result = [22.20111111, 114.02666667];
        break;
      case "Clear Water Bay":
        result = [22.26333333, 114.29972222];
        break;
      case "Happy Valley":
        result = [22.27055556, 114.18361111];
        break;
      case "HK Observatory":
        result = [22.30194444, 114.17166667];
        break;
      case "HK Park":
        result = [22.27833333, 114.16222222];
        break;
      case "Kai Tak Runway Park":
        result = [22.30472222, 114.21694444];
        break;
      case "Kau Sai Chau":
        result = [22.37027778, 114.3125];
        break;
      case "King's Park":
        result = [22.31194444, 114.17277778];
        break;
      case "Kowloon City":
        result = [22.335, 114.18472222];
        break;
      case "Kwun Tong":
        result = [22.31861111, 114.22472222];
        break;
      case "Lau Fau Shan":
        result = [22.46888889, 113.98361111];
        break;
      case "Ngong Ping":
        result = [22.25861111, 113.91277778];
        break;
      case "Pak Tam Chung":
        result = [22.40277778, 114.32305556];
        break;
      case "Peng Chau":
        result = [22.29111111, 114.04333333];
        break;
      case "Sai Kung":
        result = [22.37555556, 114.27444444];
        break;
      case "Sha Tin":
        result = [22.4025, 114.21];
        break;
      case "Sham Shui Po":
        result = [22.33583333, 114.13694444];
        break;
      case "Shau Kei Wan":
        result = [22.28166667, 114.23611111];
        break;
      case "Shek Kong":
        result = [22.43611111, 114.08147222];
        break;
      case "Sheung Shui":
        result = [22.50194444, 114.11111111];
        break;
      case "Stanley":
        result = [22.21416667, 114.21861111];
        break;
      case "Ta Kwu Ling":
        result = [22.52861111, 114.15666667];
        break;
      case "Tai Lung":
        result = [22.48472222, 114.1175];
        break;
      case "Tai Mei Tuk":
        result = [22.47527778, 114.2375];
        break;
      case "Tai Mo Shan":
        result = [22.41055556, 114.12444444];
        break;
      case "Tai Po":
        result = [22.44611111, 114.17888889];
        break;
      case "Tate's Cairn":
        result = [22.35777778, 114.21777778];
        break;
      case "The Peak":
        result = [22.26416667, 114.155];
        break;
      case "Tseung Kwan O":
        result = [22.31583333, 114.25555556];
        break;
      case "Tsing Yi":
        result = [22.34416667, 114.11];
        break;
      case "Tsuen Wan Ho Koon":
        result = [22.38361111, 114.10777778];
        break;
      case "Tsuen Wan Shing Mun Valley":
        result = [22.37555556, 114.12666667];
        break;
      case "Tuen Mun":
        result = [22.38583333, 113.96416667];
        break;
      case "Waglan Island":
        result = [22.18222222, 114.30333333];
        break;
      case "Wetland Park":
        result = [22.46666667, 114.00888889];
        break;
      case "Wong Chuk Hang":
        result = [22.24777778, 114.17361111];
        break;
      case "Wong Tai Sin":
        result = [22.33944444, 114.20527778];
        break;
      case "Yuen Long Park":
        result = [22.44083333, 114.01833333];
        break;
      default:
        break;
    }
    return result;
  }
//#endregion